import { render } from "./DeleteOffer.vue?vue&type=template&id=08d18fdd"
import script from "./DeleteOffer.vue?vue&type=script&lang=js"
export * from "./DeleteOffer.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__